exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled{pointer-events:none;opacity:.5;background:#ccc}.img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}", ""]);

// exports
